import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import FlatButton from 'material-ui/FlatButton'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import RaisedButton from 'material-ui/RaisedButton'
import Page from '../common/page/Page'
import Poll from '../../models/Poll'
import Splash from '../Splash'
import './Vote.less'

export default class Vote extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			selected: props.vote && props.vote.option,
		}

		this.handleChange = (event, value) => {
			this.setState({ selected: value })
		}

		this.handleSubmit = () => {
			this.props.submit(this.state.selected)
		}
	}

	componentWillMount() {
		this.props.load()
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.vote) {
			this.setState({
				hasVoted: true,
				selected: nextProps.vote.option,
			})
		}
	}

	render() {
		const { poll } = this.props

		if (!poll) {
			return <Splash />
		}

		return (
			<Page className="vote" title="Vote">
				<p className="question">
					{poll.question}
				</p>
				<RadioButtonGroup
					className="options"
					name="options"
					onChange={this.handleChange}
					valueSelected={this.state.selected}
				>
					{poll.options.map((label, i) =>
						<RadioButton key={i} value={i} label={label} />
					)}
				</RadioButtonGroup>
				<div className="actions">
					<RaisedButton
						label="Vote"
						onClick={this.handleSubmit}
					/>
				</div>
				<div className="actions">
					{this.state.hasVoted ? (
						<FlatButton
							label="See results"
							onClick={() => browserHistory.push(`/${poll.key}/results`)}
						/>
					) : null}
				</div>
			</Page>
		)
	}
}

Vote.propTypes = {
	load: PropTypes.func.isRequired,
	poll: PropTypes.instanceOf(Poll),
	submit: PropTypes.func.isRequired,
	vote: PropTypes.shape({
		option: PropTypes.number,
	}),
}



// WEBPACK FOOTER //
// ./src/components/vote/Vote.jsx